<script setup lang="ts">
import { CheckVerified02Icon } from "@gohighlevel/ghl-icons/24/outline";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const previewBackgroundStyle = {
  backgroundColor: "#f2f4f7",
};
</script>

<template>
  <div class="preview-container preview-container--order">
    <div class="mb-2 text-sm font-medium text-gray-600">
      {{ t("common.preview") }}
    </div>
    <div
      class="bg-container relative mx-auto flex h-full w-full items-center justify-center overflow-hidden rounded-[12px] p-8"
      :style="previewBackgroundStyle"
    >
      <div
        class="z-10 flex w-[384px] flex-col items-center gap-2 rounded-lg bg-white p-8 text-center"
      >
        <CheckVerified02Icon class="h-8 w-8 text-gray-900" />
        <div class="text-xs font-medium leading-[17px] text-gray-900">Thank you, John Doe</div>
        <div class="mt-2 w-full rounded-[12px] border border-gray-200 p-3 text-left">
          <div class="mb-3 text-xs font-medium text-gray-900">
            {{ t("common.payment.product.orderConfirmation") }}
          </div>
          <div class="space-y-2">
            <div class="flex items-start justify-between">
              <div class="flex items-start gap-2">
                <div class="h-12 w-12 shrink-0 rounded-[11px] bg-[#eff1f5]"></div>
                <div class="flex flex-col gap-1">
                  <div class="h-2.5 w-12 rounded-[11px] bg-[#eff1f5]"></div>
                  <div class="h-2.5 w-8 rounded-[11px] bg-[#eff1f5]"></div>
                </div>
              </div>
              <div class="text-xs font-bold leading-[17px] text-gray-900">$100</div>
            </div>
            <div class="flex items-start justify-between">
              <div class="flex items-start gap-2">
                <div class="h-12 w-12 shrink-0 rounded-[11px] bg-[#eff1f5]"></div>
                <div class="flex flex-col gap-1">
                  <div class="h-2.5 w-12 rounded-[11px] bg-[#eff1f5]"></div>
                  <div class="h-2.5 w-8 rounded-[11px] bg-[#eff1f5]"></div>
                </div>
              </div>
              <div class="text-xs font-bold leading-[17px] text-gray-900">$33</div>
            </div>
            <div class="mt-3 flex items-center justify-between border-t border-gray-200">
              <div class="text-xs font-medium text-gray-900">Total</div>
              <div class="text-sm font-bold leading-[20px] text-gray-900">$133</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.preview-container {
  height: auto;
  padding-bottom: 8px;
}

.preview-container--order {
  margin-bottom: 24px;
}

.bg-container {
  position: relative;
  height: 100%;
}
</style>
